import axios from "axios";
import config from './config';
import { jwtDecode } from 'jwt-decode';

const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

const _get = async (url, config = {}, isSecuredCall = true) => {
  if (isSecuredCall) {
    await refreshToken();
    apiClient.defaults.headers["Authorization"] = 'Bearer ' + localStorage.getItem("token");
  }
  return apiClient.get(url, config)
    .then(response => {
      return response.data ? response.data : response;
    }).catch(error => {
      if (error.response.status === 401) {
        return redirectToLoging();
      }
      return Promise.reject(getErrorMessage(error.response.data));
    });
}

const _delete = async (url, config = {}, isSecuredCall = true) => {
  if (isSecuredCall) {
    await refreshToken();
    apiClient.defaults.headers["Authorization"] = 'Bearer ' + localStorage.getItem("token");
  }

  return apiClient.delete(url, config)
    .then(response => {
      return response.data ? response.data : response;
    }).catch(error => {
      if (error.response.status === 401) {
        return redirectToLoging();
      }
      return Promise.reject(getErrorMessage(error.response.data));
    });
};

const _put = async (url, data = {}, config = {}, isSecuredCall = true) => {
  if (isSecuredCall) {
    await refreshToken();
    apiClient.defaults.headers["Authorization"] = 'Bearer ' + localStorage.getItem("token");
  }

  return apiClient.put(url, data, config)
    .then(response => {
      return response.data ? response.data : response;
    }).catch(error => {
      if (error.response.status === 401) {
        return redirectToLoging();
      }
      return Promise.reject(getErrorMessage(error.response.data));
    });
};


const _post = async (url, data = {}, config = {}, isSecuredCall = true) => {
  if (isSecuredCall) {
    await refreshToken();
    apiClient.defaults.headers["Authorization"] = 'Bearer ' + localStorage.getItem("token");
  }
  return apiClient.post(url, data, config)
 
    .then(response => {
      return response.data ? response.data : response;
    })
    .catch(error => {
      if (error.response?.status === 401 && window.location.pathname !== "/login") {
        return redirectToLoging();
      }
      return Promise.reject(getErrorMessage(error.response?.data));
    });
};

const refreshToken = async () => {
  let token = localStorage.getItem("token");
  console.log("token",token)
  let refreshToken = localStorage.getItem("refresh_token");

  if (!token)
    return false;

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      return await apiClient.post(
        `${config.apiBaseUrl}/auth/refresh-token`,
        {
          "accessToken": token,
          "refreshToken": refreshToken
        }
      ).then(response => {
        storeTokens(response.data.accessToken, response.data.refreshToken);
        return true;
      }).catch(error => {
        if (error.response.status === 401) {
          return redirectToLoging();
        }
        return false;
      });
    }
    return true;
  } catch (error) {
    console.log('Error decoding token:', error);
    return false;
  }
}

const storeTokens = (accessToken, refreshToken) => {
  if (localStorage.getItem("token"))
    localStorage.removeItem("token")

  if (localStorage.getItem("refresh_token"))
    localStorage.removeItem("refresh_token")

  localStorage.setItem("token", accessToken);
  localStorage.setItem("refresh_token", refreshToken);

  return;
};

const redirectToLoging = () => {
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("token");
  localStorage.setItem("isAuthenticated", false);

  if (window.location.pathname != "/login")
    return window.location.href = "/login";
};

const getErrorMessage = (error) => {
  let message = '';
  if (error.errors) {
    error.errors.forEach((error, index) => {
      message = message + error.message;
    });
  }
  else {
    message = error.detail;
  }

  return message;
}

// Export API methods
export { _get, _delete, _put, _post };